import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress, Grid } from "@mui/material";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import useQueryParams from "../../hooks/use-query-params";
import request from "../../utils/request";
import Icon from "../../components/icon";
import Flex from "../../components/flex";
import gitlab from "../../assets/icons/gitlab";
import { getGitlabRedirectUrl } from "./utils";

const H1 = styled.h1`
    font-size: 22px;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const Span = styled.span`
    font-size: 16px;
    font-weight: 300;
    opacity: 0.35;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const GitlabOauth = () => {
    const query = useQueryParams();
    const navigate = useNavigate();

    const integrateMethod = async () => {
        const code = query.get("code");
        const state = query.get("state");

        if (!code || !state) navigate("/integrations");

        try {
            await request(
                `/api/gitlab/oauth?code=${code}&state=${state}&redirect_uri=${getGitlabRedirectUrl()}`
            );
            localStorage.setItem("widt", new Date().valueOf().toString());
            navigate("/integrations/success/gitlab");
        } catch (e) {
            navigate("/integrations/failure/gitlab");
        }
    };

    React.useEffect(() => {
        integrateMethod();
    }, [query]);

    return (
        <>
            <Helmet>
                <title>Adadot - Finalising Google Integration</title>
            </Helmet>
            <Box mt={10}>
                <Grid
                    container
                    spacing={3}
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Grid item>
                        <Icon svg={gitlab} width="250px" height="auto" />
                    </Grid>
                    <Grid item style={{ textAlign: "center" }}>
                        <H1>Plugging in GitLab</H1>
                        <Span>You will be redirected momentarily</Span>
                    </Grid>
                    <Grid item style={{ marginTop: "40px" }}>
                        <Flex justifyContent="center">
                            <CircularProgress size={50} />
                        </Flex>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};

export default GitlabOauth;
